<template>
  <v-container>
    <div class="align-center">
      <span
        class="pl-2"
        style="font-size: 18px; font-weight: bold; color: #00a99d"
        >บันทึกการรักษา</span
      >
    </div>

    <v-row class="pa-0 ma-0">
      <v-col cols="12">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> อาการสำคัญ </span>
          <v-text-field
            v-model="marjor_symptoms"
            solo
            hide-details="auto"
            dense
            placeholder="กรอกข้อมูล"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> อาการปัจจุบัน </span>
          <v-text-field
            solo
            v-model="current_symptoms"
            hide-details="auto"
            dense
            placeholder="กรอกข้อมูล"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> โรคประจำตัว </span>
          <v-text-field
            solo
            v-model="congenital_disease"
            hide-details="auto"
            dense
            placeholder="กรอกข้อมูล"
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> บันทึกทางการแพทย์ </span>
          <v-textarea
            auto-grow
            v-model="medical_record"
            solo
            dense
            hide-details="auto"
            placeholder="กรอกข้อมูล"
          ></v-textarea>
        </div>
      </v-col>
      <v-col cols="12" v-if="item">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> รูปภาพ </span>
          <div v-if="item" class="pt-2">
            <img
              :src="item"
              alt="Video Screenshot"
              class="screenshot-img"
            />
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> ต้องการรับยา </span>
          <v-radio-group v-model="radioGroup" @change="chooseDrug">
            <v-radio label="รับยา" :value="true"></v-radio>
            <v-radio label="ไม่รับยา" :value="false"></v-radio>
          </v-radio-group>
        </div>
      </v-col>
      <!-- <v-col cols="12" class="d-flex flex-column">
          <div class="d-flex justify-end pt-3">
            <v-btn width="30%" dark color="#00a99d" @click="save">บันทึก</v-btn>
          </div>
        </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    item: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      marjor_symptoms: "",
      current_symptoms: "",
      congenital_disease: "",
      medical_record: "",
      radioGroup: true,
    };
  },
  methods: {
    // save() {
    //   console.log("save!");
    // },
    chooseDrug() {
      this.$emit("chooseDrug", this.radioGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  margin-top: -12px;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #0e535a;
}
.v-list-item {
  background: #e8f6f7;
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 60vh;
}
.screenshot-img {
  width: 100%;
  max-width: 450px;
  height: 250px;
  border: 2px solid #f1f1f1;
  // border-radius: 10px;
}
</style>
